import '../style/index.less';
import { BrowserRouter } from 'react-router';
import './i18n'; //for localization
import { createRoot } from 'react-dom/client';
import { AuthComponent } from './components';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material';
import { theme } from '../style/theme';
import { Buffer } from 'buffer';
import { Provider } from 'react-redux';
import { AppStore } from './store';
import './api/AxiosInterceptors';
import cspSettings from '../settings/csp/csp.settings.json';

const container = document.getElementById('root')!;
const root = createRoot(container);

const cacheValue = cspSettings.Enable
  ? createCache({
      key: 'nonce',
      nonce: Buffer.from('secretnoncephilips', 'base64').toString('base64'),
    })
  : createCache({ key: 'philips' });

root.render(
  <CacheProvider value={cacheValue}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Provider store={AppStore}>
          <AuthComponent />
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  </CacheProvider>
);
